import { Route, Switch } from "react-router-dom";

import AwardsPage from "../Awards";
import EditProfilePage from "../EditProfile";
import EvaluationPage from "../Evaluation";
import ExpoPage from "../Expo";
import HomePage from "../Home";
import NotFoundPage from "../NotFound";
import PosterPage from "../Poster";
import PostersPage from "../Posters";
import ProfilePage from "../Profile";
import React from "react";
import SessionsPage from "../Sessions";
import SpeakerPage from "../Speaker";
import VideoPage from "../Video";

const Event = () => {
  return (
    <Switch>
      <Route path="/:event" exact>
        <HomePage />
      </Route>
      <Route path="/:event/virtual-room/:roomID">
        <VideoPage />
      </Route>
      <Route path="/:event/sessions/:sessionID">
        <VideoPage />
      </Route>
      <Route path="/:event/sessions">
        <SessionsPage />
      </Route>
      <Route path="/:event/posters/:posterID">
        <PosterPage />
      </Route>
      <Route path="/:event/posters">
        <PostersPage />
      </Route>
      <Route path="/:event/awards">
        <AwardsPage />
      </Route>
      <Route path="/:event/profiles/:profileID">
        <ProfilePage />
      </Route>
      <Route path="/:event/profile">
        <EditProfilePage />
      </Route>
      <Route path="/:event/speakers/:speakerID">
        <SpeakerPage />
      </Route>
      <Route path="/:event/expo">
        <ExpoPage />
      </Route>
      <Route path="/:event/evaluation">
        <EvaluationPage />
      </Route>
      <Route>
        <NotFoundPage />
      </Route>
    </Switch>
  );
};

export default Event;
